import React from 'react';
import { IAttendeeOrganizationDTO } from '../../../api/attendees.dao';
import Text from '../text/text';
import Bell from '../../../images/svg/bell';

interface IProps {
    organizations: IAttendeeOrganizationDTO[];
    searchValue?: string;
    showBellIcon: boolean;
}

const CollapsedOrganizations = (props: IProps) => {
    const { organizations, searchValue, showBellIcon } = props;
    const organizationNames = organizations.map(el => el.name).join(', ');

    return (
        <div className='attendee-list-item__header attendee-list-item__header--collapsed'>
            <Text
                tag='div'
                message={organizationNames}
                highlightValue={searchValue}
                withHighlight
                withEllipsis
            />
            { showBellIcon && <div className='attendee-list-item__header-bell'><Bell/></div> }
        </div>
    );
};

export { CollapsedOrganizations };